







































import { Component, Vue, Prop } from 'vue-property-decorator'
import { OtherContentModule } from '@/app/store/modules/otherContent'
@Component
export default class extends Vue {
  public created() {
    this.getData()
  }
  public getData() {
    const name = 'tutorial'
    OtherContentModule.getOtherContentData({ name })
  }
  public get othersData() {
    return OtherContentModule.OtherContentData.data
  }
  public get isLoading() {
    return OtherContentModule.isLoading
  }

  // input file
  public hasFiles = {
    file_name: '',
    file_byte: '',
    file_upload: '',
  }

  // convert PDF Base 64
  public base64Pdf(event) {
    const input = event.target
    if (input.files && input.files[0]) {
      const reader = new FileReader()
      reader.onload = (e: any) => {
        this.hasFiles = {
          file_name: input.files[0].name,
          file_byte: e.target.result
            .split('data:application/pdf;base64,')
            .join(''),
          file_upload: input.files[0],
        }
      }
      reader.readAsDataURL(input.files[0])
    }
  }
  public saveData() {
    const dataToEdit = {
      name: 'tutorial',
      content: '',
      fileUpload: this.hasFiles.file_upload,
    }
    OtherContentModule.editOtherContentData(dataToEdit)
  }
}
